require('/ui/components/entitypicker/container/singleselectcontainer.module.scss.module.css');

export const container = "_container_1vbjh_1";
export const list = "_list_1vbjh_1";
export const loading = "_loading_1vbjh_1";
